import { Box, Typography } from '@mui/material';
import { type ReactElement } from 'react';

// Shown on the website details header and above a page's structure, so the amber pill reads the
// same wherever pending changes are surfaced.
export function UnpublishedChangesIndicator(): ReactElement {
  return (
    <Box
      className="vtwo:flex vtwo:items-center vtwo:gap-2 vtwo:rounded-full vtwo:bg-amber-50 vtwo:px-3 vtwo:py-1"
      role="status"
    >
      <Box className="vtwo:h-2 vtwo:w-2 vtwo:rounded-full vtwo:bg-amber-500" />
      <Typography variant="body2" className="vtwo:font-600 vtwo:text-amber-700">
        Unpublished changes
      </Typography>
    </Box>
  );
}
